import { render, staticRenderFns } from "./StatisticsStructureSelect.vue?vue&type=template&id=4c708850"
import script from "./StatisticsStructureSelect.vue?vue&type=script&lang=js"
export * from "./StatisticsStructureSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports